export const activityTableData = {
    keys: [
        "code",
        "logbook",
        "deeming_agency",
        "deeming_agency_frequency",
        "flexible_date_calculation",
        "parent",
        "edit_form",
        "activity_type",
        "standard",
        "standard_tooltip",
        "activity_description",
        "activity_text",
        "activity_tooltip",
        "code_reference",
        "code_reference_tooltip",
        "frequency",
        "test_frequency",
        "completion_threshold",
        "email_threshold",
        "quarterly_view",
        "default_total_devices",
        "start_date",
        "end_date",
        "display_order",
        "is_active",
        "can_be_linked",
        "linked_activity",
        "shift",
        "category",
        "shift_start",
        "shift_end",
        "created_at",
        "updated_at"
    ],
    config: {
        code: {
            isVisible: true,
            label: "Code",
            class: "",
            searchKey: "activities.code",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "sectors",
            commonSearchKey: "sectors",
            commonSearchObjectKey: "code"
        },
        schedule_threshold: {
            isVisible: true,
            label: "Schedule Threshold",
            class: "",
            searchKey: "activities.schedule_threshold",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "schedule_threshold"
        },
        is_active: {
            isVisible: true,
            label: "Is Active?",
            class: "",
            searchKey: "activities.is_active",
            type: "boolean",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "is_active"
        },
        can_be_linked: {
            isVisible: true,
            label: "Can Be Linked?",
            class: "",
            searchKey: "activities.can_be_linked",
            type: "boolean",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "can_be_linked"
        },
        linked_activity: {
            isVisible: false,
            label: "Linked Activity",
            class: "",
            searchKey: "activities.activity_description",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "activity_description"
        },
        calculate_next_event: {
            isVisible: true,
            label: "Calculate Next Event?",
            class: "",
            searchKey: "activities.calculate_next_event",
            type: "boolean",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "calculate_next_event"
        },
        activity_type: {
            isVisible: true,
            label: "Activity Type",
            class: "",
            searchKey: "activities.activity_type",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "activity_type"
        },
        flexible_date_calculation: {
            isVisible: true,
            label: "Flexible Date Calculation",
            class: "",
            searchKey: "activities.flexible_date_calculation",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "flexible_date_calculation"
        },
        logbook: {
            isVisible: true,
            label: "Logbook",
            class: "",
            searchKey: "logbooks.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "logbooks",
            commonSearchKey: "logbooks",
            commonSearchObjectKey: "name"
        },
        deeming_agency: {
            isVisible: true,
            label: "Deeming Agency",
            class: "",
            searchKey: "deeming_agencies.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "deeming_agency",
            commonSearchKey: "deeming_agencies",
            commonSearchObjectKey: "name"
        },
        deeming_agency_frequency: {
            isVisible: true,
            label: "DA Frequency",
            class: "",
            searchKey: "deeming_agency_frequencies.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "deeming_agency_frequency",
            commonSearchKey: "deeming_agency_frequencies",
            commonSearchObjectKey: "name"
        },
        parent: {
            isVisible: true,
            label: "Parent",
            class: "",
            searchKey: "activities.parent",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "parent"
        },
        display_order: {
            isVisible: true,
            label: "Display Order",
            class: "",
            searchKey: "activities.display_order",
            type: "float",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "display_order"
        },
        standard: {
            isVisible: true,
            label: "Standard",
            class: "",
            searchKey: "activities.standard",
            type: "window",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "standard"
        },
        standard_tooltip: {
            isVisible: true,
            label: "Standard Tooltip",
            class: "",
            searchKey: "activities.standard_tooltip",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "standard_tooltip"
        },
        activity_description: {
            isVisible: true,
            label: "Activity Description",
            class: "",
            searchKey: "activities.activity_description",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "activity_description"
        },
        activity_text: {
            isVisible: true,
            label: "Activity text",
            class: "",
            searchKey: "activities.activity_text",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "activity_text"
        },
        activity_tooltip: {
            isVisible: true,
            label: "Activity Tooltip",
            class: "",
            searchKey: "activities.activity_tooltip",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "activity_tooltip"
        },
        interval_type: {
            isVisible: true,
            label: "Interval Type",
            class: "",
            searchKey: "activities.interval_type",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "interval_type"
        },
        frequency: {
            isVisible: true,
            label: "Frequency",
            class: "",
            searchKey: "activities.frequency",
            type: "rrule",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "frequency"
        },
        test_frequency: {
            isVisible: true,
            label: "Test Frequency",
            class: "",
            searchKey: "activities.test_frequency",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "test_frequency"
        },
        completion_threshold: {
            isVisible: true,
            label: "Completion Threshold",
            class: "",
            searchKey: "activities.completion_threshold",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "completion_threshold"
        },
        email_threshold: {
            isVisible: true,
            label: "Email Threshold",
            class: "",
            searchKey: "activities.email_threshold",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "code"
        },
        code_reference: {
            isVisible: true,
            label: "Code Reference",
            class: "",
            searchKey: "activities.code_reference",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "code_reference"
        },
        code_reference_tooltip: {
            isVisible: true,
            label: "Code Reference Tooltip",
            class: "",
            searchKey: "activities.code_reference_tooltip",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "code_reference_tooltip"
        },
        quarterly_view: {
            isVisible: true,
            label: "Quarterly View",
            class: "",
            searchKey: "activities.quarterly_view",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "quarterly_view"
        },
        edit_form: {
            isVisible: true,
            label: "Event Form",
            class: "",
            searchKey: "activities.edit_form",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "edit_form"
        },
        default_total_devices: {
            isVisible: true,
            label: "Default Total Devices",
            class: "",
            searchKey: "activities.default_total_devices",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "default_total_devices"
        },
        start_date: {
            isVisible: true,
            label: "Valid From",
            class: "",
            searchKey: "activities.start_date",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "start_date"
        },
        end_date: {
            isVisible: true,
            label: "Valid To",
            class: "",
            searchKey: "activities.end_date",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "end_date"
        },
        shift: {
            isVisible: true,
            label: "Shift",
            class: "",
            searchKey: "activities.shift",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "shift"
        },
        category: {
            isVisible: true,
            label: "Category",
            class: "",
            searchKey: "activities.category",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "category"
        },
        shift_start: {
            isVisible: true,
            label: "Shift Start",
            class: "",
            searchKey: "activities.shift_start",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "shift_start"
        },
        shift_end: {
            isVisible: true,
            label: "Shift End",
            class: "",
            searchKey: "activities.shift_end",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "shift_end"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "activities.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "created_at"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "activities.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "activities",
            commonSearchKey: "activities",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};
